
import QuoteUpSquare from "../../../assets/filled/QuoteUpSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function QuoteUpSquareIcon({ className, dataTestid = "QuoteUpSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <QuoteUpSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
